function cleanSlash(path) {
  return path.replace(/\/+$/g, "");
}
function isPathsEqual(path1, path2) {
  return cleanSlash(path1) === cleanSlash(path2);
}
export {
  cleanSlash as c,
  isPathsEqual as i
};
//# sourceMappingURL=path.js.map
